// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const ExpenseSingle = () => {
//   // Extracting expenseID using regular expressions
//   const location = useLocation();
//   // const expenseID = location.pathname.match(/\/expense\/(\d+)/);
//   const expenseID = location.pathname.match(/\/expense\/(\d+)/)?.[1];

//   const [expense, setExpense] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchAccount = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/expense/${expenseID}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch expense');
//       // }
//       const data = await response.json();
//       console.log(data);
//       setExpense(data);
//       localStorage.setItem("accountData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (expenseID) {
//       fetchAccount();
//     }
//   }, [expenseID]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">expense Info</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{expense?.data.user_names}</h1>
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Id: </span>
//                                             <span className="itemValue">{expense?.data.id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{expense?.data.center_id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">User: </span>
//                     <span className="itemValue">
//                       {expense?.data.user_names}
//                     </span>
//                   </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Description: </span>
//                     <span className="itemValue">
//                       {expense?.data.description}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Transaction Type: </span>
//                     <span className="itemValue">
//                       {expense?.data.transaction_names}
//                     </span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">amount: </span>
//                     <span className="itemValue">{expense?.data.amount}</span>
//                   </div>
//                   <div className="detailItem">
//                     <span className="itemKey">Balance: </span>
//                     <span className="itemValue">{expense?.data.balances}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="User Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default ExpenseSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const ExpenseSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const expenseID = location.pathname.match(/\/expense\/(\d+)/)?.[1];
  const [expense, setExpense] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchExpense = async () => {
    try {
      const response = await fetch(`${serverUrl}/expense/${expenseID}`);
      const data = await response.json();
      setExpense(data);
      localStorage.setItem("accountData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  useEffect(() => {
    if (expenseID) {
      fetchExpense();
    }
  }, [expenseID]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Expense Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Expense Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Money Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Expense Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {expense?.data.user_names}
                      </h1>

                      <div className="mb-4">
                        <div className="text-3xl font-bold text-purple-600">
                          {formatCurrency(expense?.data.amount)}
                        </div>
                        <p className="text-sm text-gray-500">Expense Amount</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Expense Details */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <h3 className="text-lg font-medium text-gray-800 mb-4 border-b pb-2">
                    Expense Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="space-y-4">
                      {expense?.data.description && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Description
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {expense.data.description}
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Right Column */}
                    <div className="space-y-4">
                      {expense?.data.transaction_names && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Transaction Type
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {expense.data.transaction_names}
                          </p>
                        </div>
                      )}

                      {expense?.data.balances && (
                        <div>
                          <label className="block text-sm text-gray-500 mb-2">
                            Balance
                          </label>
                          <p className="text-gray-800 bg-gray-50 rounded-lg p-3">
                            {formatCurrency(expense.data.balances)}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseSingle;
